module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4wMcDAEK8b9wQAAAAJFJREFUWMPt2DEKwlAQhOF/JCBBbCWFRU7gBey9abrcIlcxTcqAGgtZ2xCepHoiMlPOvuLbLZ9YJCIOwIn86SQ950WReHSGVwvDlMcgQVUCR6BfwwDXB9S7PJg9MCYnG34oxhhjjDHGGGOMMcYYY4wxxhhjzB9jPnyJVFvo7pn2F1CmJloWEVEDly8copF0mxdvP/MUHjD9QwQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/yellowcard.png
// module id = 212
// module chunks = 0